/**
 * Wallet and bank (OkpaPay) DTOs. Money is whole naira (98 Q-03).
 * Transfers: up to ₦10,000,000 each, no holds or gates (98 Q-24/Q-24b).
 */
import { z } from 'zod';
import { Recipient } from './common';
export const MAX_TRANSFER_NAIRA = 10_000_000;
export const TRANSFER_NOTE_MAX = 140;
/** Required request header on `POST /v1/bank/transfers` (41 §3.3). */
export const IDEMPOTENCY_HEADER = 'Idempotency-Key';
export const IdempotencyKeySchema = z.string().min(8).max(128);
export const LEDGER_KINDS = [
    'starter_grant',
    'wage',
    'hustle_sale',
    'hustle_cost',
    'purchase_item',
    'sell_item',
    'rent',
    'p2p_transfer',
    'admin_adjust',
    'reversal',
];
/** `GET /v1/wallet/history?cursor=&limit=`: newest first. */
export const WalletHistoryQuerySchema = z.object({
    /** Opaque; pass `nextCursor` from the previous page. */
    cursor: z.string().max(64).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(30),
});
/** `POST /v1/bank/transfers` + `Idempotency-Key` header. */
export const TransferRequestSchema = z.object({
    /** Phone number (`EKW-482-177`) or character id. */
    to: Recipient,
    amount: z.number().int().min(1).max(MAX_TRANSFER_NAIRA),
    note: z.string().trim().max(TRANSFER_NOTE_MAX).optional(),
});
